export type TrackMessageParams = {
  action: string;
  content_type: string;
  name: string;
  event_scope: string;
  page_type?: string;
  page_type_id?: string | number;
  context?: string;
  object_type?: string;
  object_id?: number;
  object_context?: string | number;
};

type MessageEvent = {
  GA4: {
    event: 'message';
  } & Omit<TrackMessageParams, 'object_context'> & {
      object_context?: string;
    };
};

export const trackMessage =
  ({object_context, ...rest}: TrackMessageParams) =>
  (): MessageEvent => {
    return {
      GA4: {
        event: 'message',
        ...rest,
        ...(object_context !== undefined
          ? {object_context: String(object_context)}
          : {}),
      },
    };
  };
